<mat-card>
  <mat-card-title>
    <h2>Faturas</h2>
  </mat-card-title>

  <mat-card-content>
    <table mat-table [dataSource]="faturas" class="faturas">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="selecionado">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- FaturaId Column -->
      <ng-container matColumnDef="FaturaId">
        <th mat-header-cell *matHeaderCellDef>Id</th>
        <td mat-cell *matCellDef="let row">{{row.FaturaId}}</td>
      </ng-container>

      <!-- Contrato Column -->
      <ng-container matColumnDef="Contrato">
        <th mat-header-cell *matHeaderCellDef>Contrato</th>
        <td mat-cell *matCellDef="let row">{{row.Titulo}}</td>
      </ng-container>

      <!-- Competência Column -->
      <ng-container matColumnDef="Competencia">
        <th mat-header-cell *matHeaderCellDef>Competência</th>
        <td mat-cell *matCellDef="let row">{{row.Competencia}}</td>
      </ng-container>

      <!-- Vencimento Column -->
      <ng-container matColumnDef="Vencimento">
        <th mat-header-cell *matHeaderCellDef>Vencimento</th>
        <td mat-cell *matCellDef="let row">{{row.Vencimento}}</td>
      </ng-container>

      <!-- Liberada Column -->
      <ng-container matColumnDef="Liberada">
        <th mat-header-cell *matHeaderCellDef>Liberada</th>
        <td mat-cell *matCellDef="let row">
          <mat-chip *ngIf="row.Liberada">Sim</mat-chip>
          <mat-chip *ngIf="!row.Liberada">Não</mat-chip>
        </td>
      </ng-container>

      <!-- Início Período Column -->
      <ng-container matColumnDef="Inicio">
        <th mat-header-cell *matHeaderCellDef>Início Período</th>
        <td mat-cell *matCellDef="let row">{{row.Inicio}}</td>
      </ng-container>

      <!-- Valor Column -->
      <ng-container matColumnDef="Fim">
        <th mat-header-cell *matHeaderCellDef>Fim Período</th>
        <td mat-cell *matCellDef="let row">{{row.Fim}}</td>
      </ng-container>

      <!-- Valor Column -->
      <ng-container matColumnDef="Valor">
        <th mat-header-cell *matHeaderCellDef>Valor</th>
        <td mat-cell *matCellDef="let row">{{row.Valor}}</td>
      </ng-container>

      <!-- DataEmail Column -->
      <ng-container matColumnDef="DataEmail">
        <th mat-header-cell *matHeaderCellDef>DataEmail</th>
        <td mat-cell *matCellDef="let row"><mat-chip *ngIf="row.DataEmail" color="primary">{{row.DataEmail}}</mat-chip></td>
      </ng-container>

      <!-- statusOperacao Column -->
      <ng-container matColumnDef="statusOperacao">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">{{row.statusOperacao}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </mat-card-content>
  <mat-card-footer>
    <button mat-raised-button color="primary" (click)="enviarSelecionadasClicado()" [disabled]="enviandoEmail||!isAnySelected()">Enviar Email(s)</button>
    <button class="segundo-botao" mat-raised-button color="primary" (click)="enviarELiberarSelecionadasClicado()" [disabled]="enviandoEmail||!isAnySelected()">Liberar e Enviar Email(s)</button>
  </mat-card-footer>
</mat-card>

